import Http from '@/libs/axios'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    list: state => {
      return state.list
    },
  },
  mutations: {
    SET_LIST(state, ops) {
      state.list = ops
    },
  },
  actions: {
    getList({commit}, {params}) {
      return new Promise((resolve, reject) => {
        Http.get('audit-trail', { params: params }).then(response => {
          commit('SET_LIST', response.data)
          resolve()
        }).catch(error => reject(error))
      })
    },
    getAuditTrail({commit}, { auditable_type, auditable_id, params }) {
      return new Promise((resolve, reject) => {
        Http.get(`audit-trail/pagination/${auditable_type}/${auditable_id}`, { params: params }).then(response => {
          resolve(response)
        }).catch(error => reject(error))
      })
    },
  }
}
